<template>
    <div id="page-user-edit">
        <div class="vx-row">
            <div class="vx-col lg:w-2/3 w-full">
                <vx-card>
                    <div slot="no-body" class="tabs-container px-6 pt-6">
                        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
                            <vs-tab label="Modifier mes informations" icon-pack="feather" icon="icon-user">
                                <div class="tab-text">
                                    <user-edit-tab-account class="mt-4" />
                                </div>
                            </vs-tab>
                            <vs-tab label="Changer de mot de passe" icon-pack="feather" icon="icon-info">
                                <div class="tab-text">
                                    <user-password-tab-account class="mt-4" />
                                </div>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col lg:w-1/3 w-full">
                <vx-card title="Mes informations">
                    <template slot="no-body">
                        <div class="flex flex-col justify-between px-6 py-3 border border-solid d-theme-border-grey-light border-r-0 border-l-0 border-t-0">
                            <div class="flex items-start mb-5">
                                <feather-icon icon="HomeIcon" class="mr-4" />
                                <div class="">
                                    <span>Entreprise</span>
                                    <h6>{{information.customer}}</h6>
                                </div>
                            </div>
                            <div class="flex items-start mb-5">
                                <feather-icon icon="MailIcon" class="mr-4" />
                                <div class="">
                                    <span>Email</span>
                                    <h6><a :href="'mailto:' + information.email">
                                        <span v-html="displayEmail(information.email)"></span>
                                    </a></h6>
                                </div>
                            </div>
                            <div class="flex items-start mb-5">
                                <feather-icon icon="PhoneIcon" class="mr-4" />
                                <div class="">
                                    <span>Téléphone</span>
                                    <h6>{{information.phone}}</h6>
                                </div>
                            </div>
                            <div class="flex items-start mb-5">
                                <feather-icon icon="CalendarIcon" class="mr-4" />
                                <div class="">
                                    <span>Inscrit depuis</span>
                                    <h6>{{information.created_at ? information.created_at.date : ''}}</h6>
                                </div>
                            </div>
                            <div class="flex items-start mb-5">
                                <feather-icon icon="ClockIcon" class="mr-4" />
                                <div class="">
                                    <span>Dernière modification du profil</span>
                                    <h6>Le {{ information.updated_at ? information.updated_at.date : ''}} à {{information.updated_at ? information.updated_at.time : ''}} </h6>
                                </div>
                            </div>
                        </div>
                        <h4 v-if="$store.state.is_client()" class="px-6 py-4">Mes mandataires</h4>
                        <ul v-if="$store.state.is_client()" >
                            <li class="px-6 py-4 mandataire">
                                <div class="vx-row">
                                    <div class="vx-col w-full sm:w-auto">
                                        <h6>Ulrich D.</h6>
                                    </div>
                                    <div class="mandataires__actions vx-col w-full sm:w-auto ml-auto mt-2 sm:mt-0">
                                        <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" class="ml-3" />
                                    </div>
                                </div>
                            </li>
                            <li class="px-6 py-4 mandataire">
                                <div class="vx-row">
                                    <div class="vx-col w-full sm:w-auto">
                                        <h6>Alice B.</h6>
                                    </div>
                                    <div class="mandataires__actions vx-col w-full sm:w-auto ml-auto mt-2 sm:mt-0">
                                        <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" class="ml-3" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div v-if="$store.state.is_client()" class="border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light flex justify-center py-3">
                            <vs-button type="border" >Gérer mes mandataires</vs-button>
                        </div>
                    </template>


                </vx-card>
            </div>
        </div>

    </div>
</template>

<script>
    var base_self;
    var input_tempon = {
        id: '',
        name: '',
        first_name: '',
        phone: '',
        email: ''
    };

    import UserEditTabAccount from "./UserEditTabAccount";
    import UserPasswordTabAccount from "./UserPasswordTabAccount";
    export default {
        components: {UserEditTabAccount, UserPasswordTabAccount},
        data() {
            return {
                activeTab: 0,
                information: {},
                input: JSON.parse(JSON.stringify(input_tempon)),
            }
        },
        methods: {
            async users_information () {
                base_self.$vs.loading()
                let response = await base_self.$store.state.users_information({});
                
                base_self.last_page = response.data.last_page;
                base_self.information = response.data;

                base_self.information.created_at = base_self.$store.state.convertDateTime(new Date(base_self.information.created_at));
                base_self.information.updated_at = base_self.$store.state.convertDateTime(new Date(base_self.information.updated_at));

                base_self.input.id = response.data.id;
                base_self.input.name = response.data.name;
                base_self.input.first_name = response.data.first_name;
                base_self.input.phone = response.data.phone;
                base_self.input.email = response.data.email;
                base_self.$vs.loading.close()
            },
            displayEmail(email){
                var str = new String(email);
                let count = str.length
                let display = ''
                let index = 0
                let split = 27
                let rest = 0
                if (count > split){
                    while ((index+split) < count){
                        display += email.substring(index, (split+index))+'<br>'
                        rest = count - (split+index)
                        if (rest > 0 && rest < split){
                            display += email.substring(index+split)+'<br>'
                        }
                        index = index + split
                    }
                    return display
                }else return email
            }
        },
        mounted() {
            base_self.users_information();
        },
        created() {
            base_self = this;
            window.ProfileApp = this;
        }
    }
</script>

<style lang="scss">
    .mandataire {
        transition: background .15s ease-out;
        /*.mandataires__actions {*/
        /*    display: none;*/
        /*}*/

        &:hover {
            background: rgba(var(--vs-primary),.04) ;
            /*.mandataires__actions {*/
            /*    display: flex;*/
            /*}*/
        }
    }
</style>